import type { IntegrationDescriptor } from './types';

export const SETTINGS_TAB_VALUES = ['account', 'integrations'] as const;

export const SETTINGS_TABS: { value: (typeof SETTINGS_TAB_VALUES)[number]; label: string }[] = [
  { value: 'account', label: 'Account' },
  { value: 'integrations', label: 'Integrations' },
];

export const INTEGRATIONS: IntegrationDescriptor[] = [
  {
    key: 'clickup',
    kind: 'token',
    noun: 'token',
    title: 'ClickUp',
    purpose: 'Review queue, approvals, and time tracking',
    description:
      'Your personal API token drives the review queue, approvals, and time tracking. Tokens are per person — capacity numbers are attributed by whose token loaded the entry.',
    placeholder: 'pk_…',
    steps: [
      'Open ClickUp and click your avatar (bottom-left).',
      'Go to Settings → Apps.',
      'Under API Token, click Generate and copy the value.',
      'Paste it below and save.',
    ],
    link: { label: 'Open ClickUp API settings', href: 'https://app.clickup.com/settings/apps' },
  },
  {
    key: 'google',
    kind: 'oauth',
    title: 'Google Calendar',
    purpose: 'Your meetings as loggable time entries',
    description:
      'Read-only calendar access so Time Tracking can surface your meetings as loggable entries. Mission Control never creates, edits, or deletes events.',
    steps: [
      'Click Connect Google Calendar below.',
      'Pick the Google account whose calendar you work from.',
      'Grant the read-only calendar permission.',
      'You land back here once it is done.',
    ],
    link: null,
  },
  {
    key: 'slack',
    kind: 'oauth',
    title: 'Slack',
    purpose: 'Your sent messages as loggable time',
    description:
      'Read-only access to the messages you send, so Time Tracking can reconstruct the parts of your day that ClickUp and your calendar never see. Mission Control never posts to Slack.',
    steps: [
      'Click Connect Slack below.',
      'Review the permissions and approve.',
      'You land back here once it is done.',
    ],
    link: null,
  },
  {
    key: 'granola',
    kind: 'token',
    noun: 'key',
    title: 'Granola',
    purpose: 'Meeting notes for meeting processing',
    description: 'Your Granola API key lets meeting processing read your meeting notes.',
    placeholder: 'Paste your Granola API key…',
    steps: [
      'Open Granola and go to Settings.',
      'Find the API section.',
      'Create a key and copy the value.',
      'Paste it below and save.',
    ],
    link: null,
  },
];
